import butterfly from "./assets/photos/butterfly.jpg";
import Calgary from "./assets/photos/Calgary.jpg";
import cirque from "./assets/photos/cirque.jpg";
import niagara from "./assets/photos/niagara.jpg";
import redpanda from "./assets/photos/redpanda.jpg";
import harbour from "./assets/photos/harbour.JPG";
import peak from "./assets/photos/peak.JPG";
import lion from "./assets/photos/lion.jpg";
import sarrail from "./assets/photos/sarrail.JPG";
import tent from "./assets/photos/tent.jpg";
import younggoat from "./assets/photos/younggoat.jpg";
import moon from "./assets/photos/moon.jpg";
import bali from "./assets/photos/bali.JPG";
import aurora from "./assets/photos/aurora.jpg";
import bridge from "./assets/photos/bridge.jpg";
import hk from "./assets/photos/hk.jpg";
import deer from "./assets/photos/deer.jpg";
import neon from "./assets/photos/neon.jpg";
import plain from "./assets/photos/plain.jpg";
import pocaterra from "./assets/photos/pocaterra.jpg";
import valencia from "./assets/photos/valencia.jpg";
import coldplay from "./assets/photos/coldplay.JPG";
import kowloon from "./assets/photos/kowloon.JPG";
import market from "./assets/photos/market.JPG";
import stanley from "./assets/photos/stanley.jpg";
import vancouver from "./assets/photos/vancouver.jpg";

import candy from "./assets/photos/candy.jpg";

const data = {
  Photo: [
    {
      info: "Tent Ridge Horseshoe Sunrise, August 2021",
      imageURL: tent,
      alt: "tent",
      order: 1,
    },
    {
      info: "Red Panda at the Calgary Zoo, July 2022",
      imageURL: redpanda,
      alt: "redpanda",
      order: 2,
    },
    {
      info: "Aurora Borealis near Cochrane, March 2023",
      imageURL: aurora,
      alt: "aurora",
      order: 3,
    },

    {
      info: "Cirque Peak Summit, July 2022",
      imageURL: cirque,
      alt: "cirque",
      order: 4,
    },
    {
      info: "Butterfly taken at Calgary Zoo, July 2022",
      imageURL: butterfly,
      alt: "butterfly",
      order: 5,
    },
    {
      info: "Sarrail Ridge Summit, July 2022",
      imageURL: sarrail,
      alt: "sarrail",
      order: 6,
    },
    {
      info: "Beach View at Bali, January 2019",
      imageURL: bali,
      alt: "bali",
      order: 7,
    },

    {
      info: "Baby Bighorn Sheep on Pocatera Ridge, September 2022",
      imageURL: younggoat,
      alt: "goat",
      order: 8,
    },

    {
      info: "Street in Hong Kong at Night, January 2018",
      imageURL: neon,
      alt: "neon",
      order: 9,
    },

    {
      info: "Ponte 25 de Abril bridge in Lisbon, January 2018",
      imageURL: bridge,
      alt: "lisbonbridge",
      order: 10,
    },
    {
      info: "Hong Kong Skyline from Tsim Sha Tsui Promenade, January 2019",
      imageURL: hk,
      alt: "HongKongSkyline",
      order: 11,
    },
    {
      info: "Taken midway of Plain of Six Glaciers hike, July 2020",
      imageURL: plain,
      alt: "Plainsofsixglacier",
      order: 12,
    },
    {
      info: "South Pocaterra Ridge Summit, July 2020",
      imageURL: pocaterra,
      alt: "pocaterra",
      order: 13,
    },
    {
      info: "Calgary Skyline from Mt Pleasant View Point, August 2022",
      imageURL: Calgary,
      alt: "calgary",
      order: 14,
    },
    {
      info: "Ciudad de las Artes y las Ciencias during sunset, January 2018",
      imageURL: valencia,
      alt: "valencia",
      order: 15,
    },

    {
      info: "Niagara Falls, August 2022",
      imageURL: niagara,
      alt: "niagara",
      order: 16,
    },
    {
      info: "Little Doe who came to our campsite in Sparwood, June 2020",
      imageURL: deer,
      alt: "deer",
      order: 17,
    },
    {
      info: "Full Moon, January 2021",
      imageURL: moon,
      alt: "moon",
      order: 18,
    },

    {
      info: "Victoria Peak, June 2023",
      imageURL: peak,
      alt: "peak",
      order: 19,
    },

    {
      info: "Victoria Harbour at Sunset, June 2023",
      imageURL: harbour,
      alt: "harbour",
      order: 20,
    },

    {
      info: "Lion's Rock Hike in Hong Kong, August 2023",
      imageURL: lion,
      alt: "lion",
      order: 21,
    },

    {
      info: "Stanley from Twin Peaks, August 2023",
      imageURL: stanley,
      alt: "stanley",
      order: 22,
    },
    {
      info: "Cotton Candy Sky, May 2023",
      imageURL: candy,
      alt: "candysky",
      order: 23,
    },
    {
      info: "Somewhere by Kitsilano, September 2023",
      imageURL: vancouver,
      alt: "nightcalgary",
      order: 24,
    },

    {
      info: "Coldplay Concert at BC Place, September 2023",
      imageURL: coldplay,
      alt: "coldplay",
      order: 25,
    },
    {
      info: "Kowloon from the Sky, August 2023",
      imageURL: kowloon,
      alt: "kowloon",
      order: 26,
    },
    {
      info: "Richmond Night Market while Landing, August 2023",
      imageURL: market,
      alt: "market",
      order: 27,
    },
  ],
};
export default data;
